export const not = x => !x;
